import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

const BASE_URL = environment.apiUrl;

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  private baseUrl = environment.apiUrl + '/api/packages';

  constructor(private http: HttpClient) { }

  fetchTemplates(packageId?: string | null): Observable<any> {
    let url = `${this.baseUrl}/fetch_templates`;
    if (packageId) {
      url += `?package_id=${packageId}`;
    }
    return this.http.get(url);
  }

  getTemplatePreview(id: string): Observable<any> {
    return this.http.get(`${this.baseUrl}/template_preview?id=${id}`);
  }
}
